<template>
  <div class="bg-white" :class="UI.isMobile ? 'padding-xs' : 'padding'">
    <div class="flex justify-center align-center"><h3>合作伙伴管理</h3></div>

    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column label="图标">
        <template slot-scope="scope">
          <img :src="scope.row.logo" />
        </template>
      </el-table-column>

      <el-table-column prop="sort" label="排序"></el-table-column>

      <el-table-column fixed="right" width="180">
        <template slot="header" slot-scope="scope">
          <el-button
            @click="
              partnerInfo = {};
              isShow = true;
            "
            type="primary"
            size="small"
          >
            新增合作伙伴
          </el-button>
        </template>
        <template slot-scope="scope">
          <el-button
            @click="
              partnerInfo = scope.row;
              isShow = true;
            "
            type="primary"
            size="small"
          >
            编辑
          </el-button>
          <el-button
            @click="handleDeletePartner(scope.row.id)"
            type="danger"
            size="small"
          >
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>

    <div class="flex justify-center align-center full-width margin-top">
      <el-pagination
        :hide-on-single-page="total <= filterForm.page_size"
        @current-change="handleCurrentChange"
        :current-page.sync="filterForm.page"
        :page-size="filterForm.page_size"
        layout="total, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>

    <el-dialog
      title="新增合作伙伴"
      :visible.sync="isShow"
      width="800px"
      show-close
      v-if="isShow"
      :fullscreen="UI.isMobile"
    >
      <div class="flex flex-direction align-center partnerInfo">
        <el-form
          ref="partnerInfoForm"
          :model="partnerInfo"
          :rules="partnerInfoRules"
          :label-position="UI.isMobile ? 'top' : 'left'"
          :label-width="UI.isMobile ? undefined : '120px'"
          style="width: 90%;"
        >
          <el-form-item label="图标" prop="logo">
            <MediaUpload
              ref="logo"
              :action="uploadUrl + '/upload/head_pic'"
              :suffixList="[]"
              :file="partnerInfo.logo"
              @success="handlerUploadSuccess('logo')"
            ></MediaUpload>
          </el-form-item>
          
          <el-form-item label="名称" prop="name">
            <el-input
              placeholder="请输入名称"
              clearable
              v-model="partnerInfo.name"
            ></el-input>
          </el-form-item>

          <el-form-item label="排序" prop="sort">
            <el-input-number
              placeholder="请输入排序"
              clearable
              :min="0"
              :max="9999"
              v-model="partnerInfo.sort"
            ></el-input-number>
          </el-form-item>
        </el-form>

        <el-button
          class="login-button padding-xs margin-top"
          type="primary"
          size="mini"
          @click="submit()"
        >
          提交
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPartnersList,
  addPartners,
  deletePartners,
} from '@/servers/admin.js';
import { showSuccessMsg } from '@/utils/uiUtils.js';
import { mapState } from 'vuex';
import { baseUrl } from '@/utils/consts.js';
import MediaUpload from '@/components/upload/mediaUpload.vue';

export default {
  components: {
    MediaUpload,
  },

  data() {
    return {
      uploadUrl: baseUrl,
      partnerInfo: {},
      isShow: false,
      total: 0,
      tableData: [],
      filterForm: {
        page: 1,
        page_size: 10,
      },
      partnerInfoRules: {
        name: [
          {
            required: true,
            message: '请输入名称',
            trigger: 'blur',
          },
        ],
        logo: [
          {
            required: true,
            message: '请上传logo',
            trigger: 'blur',
          },
        ],
        sort: [
          {
            required: true,
            message: '请输入排序',
            trigger: 'blur',
          },
        ],
      },
    };
  },

  computed: {
    ...mapState(['UI']),
  },

  created() {
    this.flushData();
  },

  methods: {
    flushData: function() {
      let that = this;
      this.page = 1;
      getPartnersList(this.filterForm, function(res) {
        that.tableData = res.items;
        that.total = res.total;
      });
    },

    handleCurrentChange: function() {
      this.flushData();
    },

    handlerUploadSuccess: function(key) {
      this.partnerInfo[key] = this.$refs[key].uploadRes;
    },

    handleDeletePartner: function(partnerId) {
      let that = this;
      this.$confirm('确认删除(记录)?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
        center: true,
      })
        .then(() => {
          deletePartners(partnerId, function(res) {
            showSuccessMsg(res);
            that.flushData();
          });
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '取消',
          });
        });
    },

    submit: function() {
      let that = this;
      this.$refs.partnerInfoForm.validate((valid) => {
        if (valid) {
          addPartners(this.partnerInfo, function(res) {
            that.partnerInfo = {};
            that.isShow = false;
            that.flushData();
            showSuccessMsg(res);
          });
        }
      });
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/pages/index/homepage/partners.vue